@if (!canAddAnything()) {
  <app-no-permissions></app-no-permissions>
}
<div [class]="{ grid: expanded }">
  <div [class]="{ 'col-2': expanded }">
    <p-panelMenu [model]="items"></p-panelMenu>
  </div>
  <div *ngIf="expanded" class="col-10">
    <router-outlet name="panel"></router-outlet>
  </div>
</div>
